import Alpine from 'alpinejs';
// import './gp-main.css';

window.Alpine = Alpine;

Alpine.start();

const init = () => {
};

if (document.readyState !== 'loading') {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init);
}